import {
    CLOSE_RIGHT_PANE,
    OPEN_RIGHT_PANE,
} from '../actions/types/right-pane-action-types';
import {
    SWITCH_COLLECTION_TABS
} from '../../dashboard/actions/types/collection-action-types';
import {
    UPDATE_DOMAINS_FAILURE,
    UPDATE_DOMAINS_SUCCESS,
} from '../../common/actions/types/domain-management-action-types';
import {
    SWITCH_SIDE_NAV_ITEMS,
    REDIRECT_TO_LOGIN,
} from '../../common/actions/types/ui-state-action-types';
import { UNVERIFIED_ALL_DOMAINS_FOR_SENDER } from '../../common/actions/types/recognized-senders-action-types';
import { SAVE_CANVAS_SETTINGS } from '../../dashboard/actions/types/canvas-action-types';

import { combineReducers } from 'redux';
import { RIGHT_PANE_VARIANTS } from '../../right-pane/constants';

function attributes( state = {}, action ){
    let newState;
    switch( action.type ){
        case OPEN_RIGHT_PANE:
            newState = action.attributes;
            break;
        case CLOSE_RIGHT_PANE:
        case UPDATE_DOMAINS_SUCCESS:
        case UNVERIFIED_ALL_DOMAINS_FOR_SENDER:
        case UPDATE_DOMAINS_FAILURE:
            newState = {};
            break;
        default:
            newState = state;
    }

    return newState;
}

function activeRightPane( state = null, action ){
    let newState;

    switch( action.type ){
        case OPEN_RIGHT_PANE:
            newState = action.activeRightPane;
            break;
        case CLOSE_RIGHT_PANE:
        case SWITCH_COLLECTION_TABS:
        case SWITCH_SIDE_NAV_ITEMS:
        case REDIRECT_TO_LOGIN:
        case UPDATE_DOMAINS_SUCCESS:
        case UNVERIFIED_ALL_DOMAINS_FOR_SENDER:
        case SAVE_CANVAS_SETTINGS:
            newState = null;
            break;
        default:
            newState = state;
    }
    return newState;
}

function title( state = '', action ){
    let newState;
    switch( action.type ){
        case OPEN_RIGHT_PANE:
            newState = action.title;
            break;
        default:
            newState = state;
    }

    return newState;
}

function subtitle( state = '', action ){
    let newState;
    switch( action.type ){
        case OPEN_RIGHT_PANE:
            newState = action.subtitle;
            break;
        default:
            newState = state;
    }

    return newState;
}

function variant( state = RIGHT_PANE_VARIANTS['standard'], action ){
    let newState;
    switch( action.type ){
        case OPEN_RIGHT_PANE:
            newState = action.variant;
            break;
        default:
            newState = state;
    }

    return newState;
}

export default combineReducers( {
    activeRightPane,
    attributes,
    subtitle,
    title,
    variant
} );
